"use strict";

exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/dom-helpers/cjs/hyphenate.js
// module id = 6694
// module chunks = 0